function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import BaseButton from '../base-button';
import warn from '../util/warn';
import { jsx as ___EmotionJSX } from "@emotion/core";
var hrefWarning = warn('development');
var LinkButton = /*#__PURE__*/forwardRef((props, ref) => {
  if (!props.href) {
    hrefWarning("You've added a LinkButton without an href which creates an accessibility violation, please change to a Button instead");
  }
  return ___EmotionJSX(BaseButton, _extends({
    forwardRef: ref
  }, props, {
    type: "link"
  }));
});
LinkButton.displayName = 'LinkButton';
export default LinkButton;